export default {
  send: 'Senden',
  typeMessage: 'Nachricht eingeben ...',
};
